import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { signIn } from '../../redux/actions/authActions'
import { Link, useNavigate } from 'react-router-dom'
import styles from '../../sass/signin.module.scss'
import { Icons, IMG } from '../../constant'
import { toast } from 'react-toastify'

const SignIn = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loader } = useSelector((state) => state.user);
  const [error, setError] = useState(null);

  const handleSignIn = () => {
   
    const data = { email, password };

    dispatch(signIn(data))
      .unwrap()
      .then(() => {
        toast.success('You have signed in successfully');
        navigate(-1);
      })
      .catch((error) => {
        if (error.errors && typeof error.errors === 'object') {
          const errorMessages = Object.values(error.errors).flat(); // Convert errors object to an array of messages
          setError(errorMessages);
        } else {
            setError(error.message || 'Failed to reset password. Please try again.');
        }
      });
  };

  return (
    <div className={styles.AuthSectionContainer}>
      <div className={styles.AuthSectionContainer_body} style={{ backgroundImage: `url(${IMG.authblur})` }}>
        <img src={IMG.logo} className={styles.AuthSectionContainer_logo} alt='logo' />
        <h1 className={styles.AuthSectionContainer_title}>Welcome Back!</h1>
        <p className={styles.AuthSectionContainer_subtitle}>Sign in to access your account and explore <br />the best dental products.</p>

        <input
          type="email"
          placeholder="Enter your email address"
          className={styles.AuthSectionContainer_form_input}
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
       
        <div className={styles.AuthSectionContainer_password_wrapper}>
          <input
            type={showPassword ? 'text' : 'password'}
            placeholder="Enter your password"
            className={styles.AuthSectionContainer_form_input}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          <div onClick={() => setShowPassword(!showPassword)} className={styles.AuthSectionContainer_password_icon}>
            {showPassword ? <img src={Icons.eyeFrame} alt='eyeFrame' /> : <img src={Icons.eyeSlash} alt='eyeslash' />}
          </div>
        </div>

        <div className={styles.AuthSectionContainer_remfor_wrapper}>
            <div className={styles.AuthSectionContainer_remfor_body}>
              <input type="checkbox" className={styles.AuthSectionContainer_checkboxInput} />
              Remember me
            </div>
         
          <Link
            to='/forgot-password'
            className={styles.AuthSectionContainer_forgot_link}
          >
            Forgot Password?
          </Link>
        </div>


        {loader ? (
          <button
            className={styles.ActionButton_fill}
            disabled
          >
            Please wait...
          </button>
        ) : (
          <button
            onClick={handleSignIn}
            className={styles.ActionButton_fill}
          >
            Sign In
          </button>
        )}

        {error && (
        <div className={styles.AuthSectionContainer_errors}>
            {Array.isArray(error)
            ? error.map((errMsg, index) => <div key={index}>{errMsg}</div>)
            : error}
        </div>
        )}

        <div className={styles.AuthSectionContainer_footer}>
          <span className="">Don't have an account?</span>
          <Link to='/signup' className={styles.AuthSectionContainer_link}>Create one now</Link>
        </div>
      </div>
    </div>
  );
};

export default SignIn;
